"use client";

import { playPriceLandSound } from "@/lib/ui-sounds";
import { motion, useMotionValueEvent, useSpring } from "framer-motion";
import { useEffect, useRef, useState } from "react";

type AnimatedPriceProps = {
  value: number;
  className?: string;
  playSoundOnChange?: boolean;
};

const AnimatedPrice = ({
  value,
  className,
  playSoundOnChange = true,
}: AnimatedPriceProps) => {
  const spring = useSpring(value, {
    stiffness: 90,
    damping: 24,
    mass: 0.6,
  });
  const [display, setDisplay] = useState(value);
  const [bump, setBump] = useState(false);
  const playedSound = useRef(true);

  useEffect(() => {
    playedSound.current = false;
    spring.set(value);
    setBump(true);
    const t = window.setTimeout(() => setBump(false), 400);
    return () => window.clearTimeout(t);
  }, [value, spring]);

  useMotionValueEvent(spring, "change", (latest) => {
    setDisplay(Math.round(latest));
    if (
      playSoundOnChange &&
      !playedSound.current &&
      Math.abs(latest - value) < 0.5
    ) {
      playedSound.current = true;
      playPriceLandSound();
    }
  });

  return (
    <motion.span
      className={className}
      animate={{ scale: bump ? [1, 1.06, 1] : 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      {display}
    </motion.span>
  );
};

export default AnimatedPrice;
